<template>
  <div class="peoSinRank">
    <div class="content-title" style="display:inline-block;">人员单项排名（{{totalCount}}人）</div>
    <span style='color: #2CB9B8;cursor: pointer; float:right;font-weight: normal' @click="exportDetail">导出</span>
    <el-table
    :data="tableData"
    border
    :row-class-name="tableRowClassName"
    @sort-change='sortChange'
    :default-sort="{prop: 'rank', order: 'ascending'}"
    v-loading="loading"
   >
   <template v-for="item in detailConfig">
    <el-table-column
        :prop="item.prop"
        :label="item.label"
        :key="item.prop"
        :width="item.width||''"
        :sortable="item.sortable"
        :fixed="item.fixed"
        :min-width="item.min_width||''"
      >
          <template slot-scope="scope">
            <div v-if="item.prop=='operator_name'">
              <span @click='getLastProducLine(scope.row.operator_name)' style="color:#1890ff;cursor: pointer;font-weight: normal;">{{scope.row.operator_name}}</span>
            </div>
            <div v-else>{{scope.row[item.prop]}}</div>
          </template>
        </el-table-column>
      </template>
    </el-table>
    <template>
      <div class="pagination">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="pageSize"
          layout="total,prev, pager, next, jumper"
          :total="totalCount"
        ></el-pagination>
      </div>
    </template>
  </div>
</template>

<script>
import { detailConfigs, bus } from '../overviewConfig'
import { createNamespacedHelpers } from 'vuex'
import { downloadBlobFile } from '@/utils/download'
import {
  getSingRank,
  singRankExport,
  getProductLine
} from '@/api/personnelPortraitOverview'
const { mapState } = createNamespacedHelpers('personnelPortraitOverview')
const mixin = {
  computed: {
    ...mapState({
      tabName: (state) => state.activeTabName,
      formData: (state) => state.formData,
      inquireNum: (state) => state.inquireNum
    })
  },
  methods: {}
}
export default {
  data () {
    return {
      tableData: [],
      totalCount: 0,
      detailConfig: detailConfigs['danxiangzuoye'],
      currentPage: 1, // 第几页
      pageSize: 10, // 每页有多少
      operator_type: 'zhizuo',
      sort_order: 'desc',
      loading: false,
      allOnclick: {}
    }
  },
  mixins: [mixin],
  props: ['isIframe'],
  computed: {
    // 接口发送时传递的参数
    queryParams: function () {
      return {
        operator_type: this.operator_type,
        zb: this.zb,
        start_time: this.formData.start_time,
        end_time: this.formData.end_time,
        production_line: this.formData.production_line,
        outsourcer: this.formData.outsourcer,
        task_type: this.formData.task_type,
        task_label: this.formData.task_label,
        start: this.start,
        end: this.end,
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        sort_order: this.sort_order,
        platform: this.formData.platform
      }
    }
  },
  mounted () {
    let _this = this
    // 事件总线接收左侧下拉框选择的数值
    bus.$on('zb', function (obj) {
      let { val } = obj
      _this.zb = val
      _this.setDetailConfig(_this.tabName)
      _this.queryParams['zb'] = _this.zb
      _this.getTableData()
    })
    /** 事件总线接收柱形图点击时传递来的start/end
     * 使用allOnclick来检测start是否被点击过
     * 同一个start第一次被点击 查询此start/end的数据 同一个start第二次被点击 查询全部数据，start/end为空
     * 点击A柱形图后，点击B柱形图，恢复allOnclick中A的start为‘未点击过’的状态，只设置B的start为‘点击’状态
     * allOnclick[start]为true则表示已经被点击一次，为false表示未被点击（查询全部数据）
     */
    bus.$on('singRank', function (val) {
      let { start, end } = val
      _this.start = start
      _this.end = end
      let flag = _this.allOnclick[start]
      if (_this.allOnclick[start]) {
        _this.queryParams['start'] = ''
        _this.queryParams['end'] = ''
      } else {
        _this.queryParams['start'] = _this.start
        _this.queryParams['end'] = _this.end
      }
      for (let key in _this.allOnclick) {
        _this.allOnclick[key] = false
      }
      _this.allOnclick[start] = !flag
      _this.getTableData()
    })
    this.setDetailConfig(this.tabName)
  },
  methods: {
    // 获取表格数据
    async getTableData () {
      let flag = this.requiredParams()
      if (flag) {
        this.loading = true
        let res = await getSingRank(this.queryParams)
        if (res) {
          this.loading = false
          let { totalCount, data: tableData } = res
          for (let i = 0; i < tableData.length; i++) {
            tableData[i].operator_name =
              tableData[i].operator + '(' + tableData[i].operator_cn + ')'
          }
          this.totalCount = totalCount || 0
          // this.detailConfig[0]['label'] = '排名(' + this.totalCount + ')'
          this.tableData = tableData
        }
      }
    },

    // 设置表格样式
    tableRowClassName ({ row, rowIndex }) {
      if (rowIndex % 2 === 1) {
        return 'warning-row'
      }
      return ''
    },
    // handleSizeChange (val) {
    //   this.pageSize = val
    //   console.log(`每页 ${val} 条`)
    // },
    handleCurrentChange (val) {
      this.currentPage = val
      this.queryParams['pageNo'] = this.currentPage
      this.getTableData()
    },

    /* 根据当前是作业员还是内检员设置operator_type和表头
     *  恢复左侧柱形图设置的start/end为空
     *  恢复排序为从小到大
     */
    setDetailConfig (val) {
      this.start = ''
      this.end = ''
      this.queryParams['start'] = ''
      this.queryParams['end'] = ''
      if (val === 'zhizuo') {
        this.detailConfig = detailConfigs['danxiangzuoye']
        // this.detailConfig[0]['label'] = '排名(' + this.totalCount + ')'
        this.operator_type = 'zhizuo'
        this.queryParams['operator_type'] = this.operator_type
      } else {
        this.detailConfig = detailConfigs['danxiangneijian']
        // this.detailConfig[0]['label'] = '排名(' + this.totalCount + ')'
        this.operator_type = 'neijian'
        this.queryParams['operator_type'] = this.operator_type
      }
      this.sort_order = 'desc'
      this.queryParams['sort_order'] = this.sort_order
      this.getTableData()
    },

    // 设置排序规则
    sortChange (val) {
      this.sort_order = this.sort_order === 'asc' ? 'desc' : 'asc'
      this.queryParams['sort_order'] = this.sort_order
      this.getTableData()
    },

    // 判断必须参数是否全部有值
    requiredParams () {
      if (this.queryParams['operator_type'] && this.queryParams['start_time'] && this.queryParams['end_time'] && this.queryParams['pageNo'] && this.queryParams['pageSize'] && this.queryParams['sort_order'] && this.queryParams['zb']) {
        return true
      } else {
        return false
      }
    },

    // 导出
    async exportDetail () {
      const paramsObj = {
        operator_type: this.queryParams['operator_type'],
        start_time: this.queryParams['start_time'],
        end_time: this.queryParams['end_time'],
        zb: this.queryParams['zb'],
        production_line: this.queryParams['production_line'],
        outsourcer: this.queryParams['outsourcer'],
        task_type: this.queryParams['task_type'],
        task_label: this.queryParams['task_label'],
        start: this.queryParams['start'],
        end: this.queryParams['end'],
        platform: this.queryParams['platform']
      }
      const data = await singRankExport(paramsObj)
      downloadBlobFile(data)
    },

    // 链接到详情页时，得到当前人员的最后一个产线
    async getLastProducLine (row) {
      let operatorEn = row.split('(')[0]
      let paramsObj = {
        start_time: this.queryParams['start_time'],
        end_time: this.queryParams['end_time'],
        operator: operatorEn,
        operator_type: this.queryParams['operator_type'],
        zb: this.queryParams['zb'],
        platform: this.queryParams['platform'],
        task_type: this.queryParams['task_type'],
        task_label: this.queryParams['task_label'],
      }
      let res = {}
      if (!this.queryParams['production_line']) {
        res = await getProductLine(paramsObj)
      } else {
        res.production_line = this.queryParams['production_line']
      }
      if (JSON.stringify(res) !== '{}') {
        let { production_line: productionLine } = res
        let queryObj = {
          'operator': operatorEn,
          'production_line': productionLine,
          'start_time': this.queryParams['start_time'],
          'end_time': this.queryParams['end_time'],
          'platform': this.queryParams['platform'],
          'task_type': this.queryParams['task_type'],
          'task_label': this.queryParams['task_label'],
          'outsourcer': this.queryParams['outsourcer']
        }
        if (this.isIframe) {
          queryObj['iframe'] = '1'
        }
        // console.log('queryObj', queryObj, 'paramsObj', paramsObj, 'this.queryParams', this.queryParams)
        this.$router.push({
          path: '/personnel-portrait/personnel-portrait-details',
          query: queryObj
        })
      }
    }
  },
  watch: {
    // 监听tab(内检员/作业员)是否变化 恢复排序的dom元素为默认样式，即上面的三角形高亮
    tabName: function (val) {
      let domobj = document.querySelectorAll('th.el-table_2_column_5.is-leaf.is-sortable:not(.is-hidden)')
      domobj[0].className = 'el-table_2_column_5 ascending  is-leaf is-sortable'
      this.setDetailConfig(val)
    },

    // 监听是否点击查询，为四个参数赋值。恢复start/end为默认值 恢复默认排序规则 恢复排序dom为默认样式
    inquireNum: function (val) {
      this.queryParams['start_time'] = this.formData['start_time']
      this.queryParams['end_time'] = this.formData['end_time']
      this.queryParams['production_line'] = this.formData['production_line']
      this.queryParams['outsourcer'] = this.formData['outsourcer']
      this.queryParams['task_type'] = this.formData['task_type']
      this.queryParams['task_label'] = this.formData['task_label']
      this.start = ''
      this.end = ''
      this.queryParams['start'] = ''
      this.queryParams['end'] = ''
      this.sort_order = 'desc'
      this.queryParams['sort_order'] = this.sort_order
      this.currentPage = 1 // 重置页数
      let domobj = document.querySelectorAll('th.el-table_2_column_5.is-leaf.is-sortable:not(.is-hidden)')
      domobj[0].className = 'el-table_2_column_5 ascending    is-leaf is-sortable'
      this.getTableData()
    }
  }
}
</script>
<style>
body .el-table th {
  display: table-cell !important;
}
.peoSinRank {
  /* position: relative;
    height: 100%; */
  overflow: hidden;
}
.peoSinRank .el-table .has-gutter th {
  /* padding:8px 0px; */
  background: rgba(246, 247, 251, 1);
  font-size: 14px;
}
.peoSinRank .el-table .has-gutter th {
  height: 20px !important;
}
.peoSinRank .el-table .has-gutter th .cell {
  height: 20px !important;
}
.peoSinRank .el-table .el-table__row td {
  height: 40x;
  font-size: 12px;
  /* padding: 4px 0px; */
  padding: 0;
}
.peoSinRank .el-table .warning-row {
  background: rgba(246, 247, 251, 1);
}
.peoSinRank .el-table__fixed-header-wrapper th {
  /* padding: 7px 0px 4px; */
  height: 20px !important;
  background: rgba(246, 247, 251, 1);
  border-bottom: 1px solid rgba(246, 247, 251, 1);
}
.peoSinRank .el-table__fixed-header-wrapper th .cell {
  height: 20px;
}
.peoSinRank .cell .caret-wrapper {
  height: 20px;
}
.peoSinRank .el-table .sort-caret.ascending {
  top: -3px;
}
.peoSinRank .el-table .sort-caret.descending {
  bottom: -1px;
}
.peoSinRank .pagination {
  /* position: absolute;
    bottom: 0px;
    right: 0px; */
  /* float: right; */
  text-align: right;
}
.peoSinRank .content-title,
.peoSinRank span {
  height: 40px;
  font-size: 14px;
  font-weight: bold;
  color: rgba(7, 16, 49, 1);
  line-height: 40px;
}
</style>
